<template>
	<div class="detailsBox">
		<div class="top">
			<p class="text1" @click="closeFun">返回</p>
			<p class="text2">服务商详情</p>
			<img class="close" src="./img/close.png" @click="closeFun">
		</div>
		<div class="box">
			<img class="logo" :src="dataDetail.logo">
			<div class="content">
				<div class="xingxing">
					<span class="text1">{{dataDetail.name}}</span>
					<span>
						<img src="./img/xingxing.png" v-for="item in dataDetail.zhLevel">
						<img src="./img/xingxing1.png" v-for="item in 5-dataDetail.zhLevel">
					</span>
				</div>
				<p class="text2">{{dataDetail.des || '暂无'}}</p>
				<p class="text3">机构类型：<span>{{dataDetail.category}}</span></p>
				<p class="text4">机构所在地：<span>{{dataDetail.address}}</span></p>
				<p class="text5"><span>机构简介：</span>{{dataDetail.des || '暂无'}}<span></span></p>
				<p class="text4">联系邮箱：<span>{{dataDetail.email}}</span></p>
				<p class="text4">联系电话：<span>{{dataDetail.companyTel || '暂无'}}</span></p>
			</div>
			<div class="tanchaung" v-if="messageShow">
				<h4>星使订单通知</h4>
				<p>星使正在参与{{messageShow.caseNo}}救援案件 订单节点：{{statusFun(messageShow.caseState)}}</p>
			</div>			
		</div>
		<div class="shipin">
			<p>视屏通话</p>
		</div>
		
	</div>
</template>

<script>	
	import { getInstituteDetail } from '@/views/axios/api.js';
	import constants from "@/util/constants.js";
	export default{
		data(){
			return {
				dataDetail:{
					name:'',
					zhLevel:5,					
				},
				messageShow:null,
			}
		},
		methods:{
			closeFun(){
				this.$emit('childClose')
			},
			getInstituteDetail(instiId){
				var data={
					instiId
				}
				getInstituteDetail(data)
				.then(res => {
					this.dataDetail=res.data.obj
					if(res.data.obj2){
						this.messageShow=res.data.obj2
					}else{
						this.messageShow=false
					}			
				})
				.catch(err =>{
					console.log(err)
				})
			},
			statusFun(id){
				return constants.pt2txt2(id).node
			}
		}
	}
</script>

<style scoped="scoped">
.detailsBox p{font-size: 14px;}
.detailsBox .top{overflow: hidden;position: relative;padding: 0 20px;height: 60px;border-bottom: 1px solid #eee;}
.detailsBox .top p{line-height: 60px;}
.detailsBox .top >.text1{float: left;background: url(./img/back.png) no-repeat left center;padding-left: 30px;cursor: pointer;}
.detailsBox .top >.text2{text-align: center;font-size: 20px;}
.detailsBox .top .close{position: absolute;top: 20px;right: 20px;cursor: pointer;}
.detailsBox .box{padding: 20px 50px;overflow: hidden;}
.detailsBox .box .logo{float: left;width: 160px;height: 100px;}
.detailsBox .box .content{float: left;margin-left: 20px;width: calc(100% - 180px);}
.detailsBox .xingxing{margin-top: 20px;}
.detailsBox .xingxing *{vertical-align: middle;}
.detailsBox .xingxing .text1{font-size: 18px;}

.detailsBox .text2{color: #666;line-height: 30px;text-overflow: ellipsis;white-space: nowrap;width: 300px;overflow: hidden;}
.detailsBox .text3{margin-top: 20px;}
.detailsBox .text4{margin-top: 10px;}
.detailsBox p>span{color: #666;}
.detailsBox .text5{margin-top: 10px;overflow: hidden;}
.detailsBox .text5  span:first-child{color: #333;float:left;}
.detailsBox .text5  span:last-child{float:left;width: calc(100% - 80px);}
.shipin{overflow: hidden;padding:20px 60px;border-top: 1px solid #eee;}
.shipin p{float: right;background: url(./img/shipin.png) no-repeat left center;padding-left: 40px;background-size: 30px;line-height: 20px;cursor: pointer;}
.tanchaung{width: 300px;padding: 30px 20px;text-align: center;position: absolute;right: 80px;bottom: 70px;box-shadow: 0 0 10px rgba(0,0,0,0.3);background: white;}
.tanchaung h4{margin-bottom: 20px;font-size: 18px;font-weight: normal;}
.tanchaung p{color: #666;line-height: 30px;}
</style>


// WEBPACK FOOTER //
// src/views/map/details.vue